import { useFormikContext } from 'formik'

import { Order } from '@consumer/graphql'
import { ModalContent } from '../Common/ModalContent'
import { ICloseModalOptions } from '../InstructionsModal'
import { InstructionsForm, InstructionsFormType } from './InstructionsForm'

export interface InstructionsFormModalContentProps {
  order: Order
  closeModal: ({ clearAddressFields, clearGeocode, showToast, toastProps }: ICloseModalOptions) => void
  includeTermsAndConditions: boolean
}

export const InstructionsFormModalContent = ({
  order,
  closeModal,
  includeTermsAndConditions,
}: InstructionsFormModalContentProps) => {
  const { isSubmitting, isValid, handleSubmit } = useFormikContext<InstructionsFormType>()

  return (
    <ModalContent
      headerMain={'Add Delivery Instructions'}
      headerSecondary={
        'Delivery instructions and access codes help ensure your driver knows exactly where to deliver your package and how to get there.'
      }
      submitText="Save My Instructions"
      onSubmit={handleSubmit}
      closeModal={closeModal}
      disabled={isSubmitting || !isValid}
      loading={isSubmitting}
      includeTermsAndConditions={includeTermsAndConditions}
      termsAndConditionsAction={'adding instructions'}
    >
      <InstructionsForm order={order} />
    </ModalContent>
  )
}
